import React, {useEffect, useState} from 'react';
import {useAgyleConfigStyles} from '../../agyle_configuration';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {mapHospitalList, multiHospitalMode, wardsList} from '../../../../store/reducers/ward';
import _ from 'lodash';
import AgyleDictionaryField from '../../../../components/ui/selector/agyleDictionaryField';
import {Box, FormControl, FormControlLabel, FormLabel, RadioGroup} from '@mui/material';
import Chip from '@mui/material/Chip';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import Radio from '@mui/material/Radio';

const WardSelectionCleaningRequest = ({list, onAdd}) => {
    const classes = useAgyleConfigStyles();
    const {t} = useTranslation();

    // Selectors
    const wards = useSelector(wardsList);
    const isMultiHospitalMode = useSelector(multiHospitalMode);
    const hospitalList = useSelector(mapHospitalList);

    // Ward list
    const [wardsLoading, setWardsLoading] = useState(false);
    const [wardsListActive, setWardsListActive] = useState([]);

    // Selected ward
    const [facilityId, setFacilityId] = useState(null);
    const [selectedWard, setSelectedWard] = useState(null);
    const [state, setState] = useState(null);

    useEffect(() => {
        setWardsLoading(true);
        let filtered = _.filter(wards, w => w.active && w.wardsId.length === 1);
        if (isMultiHospitalMode && facilityId) {
            filtered = _.filter(filtered, w => w.hospitalId === facilityId);
        }
        setWardsListActive(filtered);
        setWardsLoading(false);
    }, [wards, isMultiHospitalMode, facilityId]);

    useEffect(() => {
        if (isMultiHospitalMode) setSelectedWard(null);
    }, [facilityId]);

    const getValue = () => {
        if (!facilityId) return null;
        return _.find(hospitalList, {__id: facilityId}) || null;
    };

    const handleChangeHospital = (_e, val) => {
        setFacilityId(val?.__id);
    };

    const onSave = () => {
        onAdd({
            hospitalId: facilityId,
            wardId: selectedWard?.wardsId[0],
            option: state,
            name: selectedWard?.name,
            id: selectedWard?.__id,
        });
        setFacilityId(null);
        setSelectedWard(null);
        setState(null);
    };

    const handleChangeOption = (event) => {
        setState(event.target.value);
    };

    return (
        <>
            <div className={classes.divRow} style={{gap: 5}}>
                {isMultiHospitalMode &&
                    <AgyleDictionaryField
                        label={t('Hospital')}
                        onChange={handleChangeHospital}
                        options={hospitalList}
                        value={getValue()}
                        getOptionLabel={option => option.description}
                        isOptionEqualToValue={(option, value) => option.__id === value.__id}
                        renderOption={(props, option) => (
                            <Box component="li" {...props}>
                                <Chip
                                    label={option?.__id || 'UNK'}
                                    style={{marginRight: 10, width: 80}}
                                    size="small"
                                />
                                {option.description}
                            </Box>
                        )}
                        fullWidth
                    />
                }

                <AgyleDictionaryField
                    options={wardsListActive}
                    getOptionLabel={option => option.name}
                    value={selectedWard}
                    isOptionEqualToValue={(option, value) => option.__id === value.__id}
                    onChange={(_, val) => setSelectedWard(val)}
                    label={t('Ward')}
                    loading={wardsLoading}
                    renderOption={(props, option) => (
                        <Box component="li" {...props}>
                            <Chip
                                label={option.wardsId[0]}
                                style={{marginRight: 10, width: 80}}
                                size="small"
                            />
                            {option.name}
                        </Box>
                    )}
                    disabled={isMultiHospitalMode && !facilityId}
                />
            </div>

            <div className={classes.radioButtons}>
                <FormControl>
                    <FormLabel>
                        {t('Ward manage by')}
                    </FormLabel>

                    <RadioGroup
                        value={state}
                        onChange={handleChangeOption}
                    >
                        <FormControlLabel
                            value="internal"
                            control={<Radio/>}
                            label={t('Internal')}
                            disabled={!selectedWard}
                        />

                        <FormControlLabel
                            value="external"
                            control={<Radio/>}
                            label={t('External')}
                            disabled={!selectedWard}
                        />
                    </RadioGroup>
                </FormControl>
            </div>

            <div className={classes.action}>
                <AgyleButton
                    onClick={onSave}
                    variant="contained"
                    disabled={!state}
                >
                    {t('Save')}
                </AgyleButton>
            </div>
        </>
    );
};

export default WardSelectionCleaningRequest;